import React from 'react';
import Reveal from './Reveal';
import Eyebrow from './Eyebrow';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';
import { Badge } from './ui/badge';
import { journey } from '../data/content';

const Journey = () => {
  return (
    <section id="journey" className="scroll-mt-20 snap-start py-24 md:py-32">
      <div className="container">
        <Reveal>
          <Eyebrow>04 — The journey so far</Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="max-w-2xl text-[clamp(2rem,3.6vw,3rem)] font-bold tracking-tight">
            Every role taught me a different piece of the same job.
          </h2>
        </Reveal>

        <div className="mt-12">
          {journey.map((item, i) => (
            <Reveal key={item.id} delay={0.06 + i * 0.05} className="grid grid-cols-[1.4rem_1fr] gap-4 sm:grid-cols-[2rem_1fr] sm:gap-5">
              <div className="flex flex-col items-center">
                <span className="mt-1.5 h-3 w-3 shrink-0 rounded-full border-2 border-primary-light bg-background" />
                {i !== journey.length - 1 && <span className="mt-1.5 w-px flex-1 bg-border-strong" />}
              </div>
              <div className="pb-14">
                <span className="font-mono text-[0.8rem] font-medium tracking-wide text-muted">{item.period}</span>
                <div className="mt-1 flex flex-wrap items-center gap-2">
                  <h3 className="text-[clamp(1.4rem,2.4vw,1.9rem)] font-bold">{item.org}</h3>
                  {item.tag && <Badge variant={item.tagVariant || 'tag'}>{item.tag}</Badge>}
                </div>
                <p className="mt-1 text-[0.95rem] text-foreground/90">
                  {item.role} · {item.location}
                </p>
                <p className="mt-3 max-w-[60ch] text-[1.02rem] leading-relaxed text-muted">{item.impact}</p>

                {item.points.length > 0 && (
                  <Accordion type="single" collapsible className="mt-2">
                    <AccordionItem value={item.id} className="border-none">
                      <AccordionTrigger className="flex-none w-auto justify-start gap-2 py-2 font-mono text-[0.8rem] text-accent-lavender hover:no-underline [&>svg]:order-first [&>svg]:h-3 [&>svg]:w-3">
                        What I actually did
                      </AccordionTrigger>
                      <AccordionContent className="pb-0 pt-1">
                        <ul className="flex flex-col gap-3">
                          {item.points.map((point, idx) => (
                            <li key={idx} className="relative max-w-[62ch] pl-5 text-[0.96rem] leading-relaxed text-muted">
                              <span className="absolute left-0 text-faint">—</span>
                              {point}
                            </li>
                          ))}
                        </ul>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journey;
